export default {
    namespaced: true,

    state: {
        property: null,
    },

    getters: {
        hasProperty: (state) => {
            return (state.property && Object.keys(state.property).length !== 0);
        },
    },

    actions: {
        getRow({ commit }) {
            return axios.get('/api/leads/property')
            .then((response) => {
                commit('setProperty', response.data.data);
            })
            .catch((error) => {
                commit('setProperty', {});
            });
        },
    },

    mutations: {
        setProperty(state, property) {
            state.property = property;
        },
    },
};
